import { DesignSystem } from "../design-system";
import { MessageBar } from "./message-bar.js";
import { MessageBarStyles, MessageBarTemplate } from "@fluentui/web-components";
/**
 * The Fabric MessageBar Element definition.
 *
 * @public
 * @remarks
 * HTML Element: `<fabric-message-bar>`
 */
export const definition = MessageBar.compose({
    name: `${DesignSystem.prefix}-message-bar`,
    template: MessageBarTemplate,
    styles: MessageBarStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=message-bar.definition.js.map